import * as React from "react";
import { withStores } from "stores";
import { PageHeadingProps } from "../typings";
import { UitkHeading } from "uitk-react-text";
import { useLocalization } from "@shared-ui/localization-context";
import { observer } from "mobx-react";

const PageHeadingWizard = withStores(
  "compositionStore",
  "flexModuleModelStore"
)(
  observer((props: PageHeadingProps) => {
    const { formatText } = useLocalization();
    const { compositionStore, flexTemplateNode, context } = props;
    const { pageHeading } = compositionStore;
    const { options } = flexTemplateNode;
    const headingSize = context.deviceInformation && context.deviceInformation.mobile ? 800 : 900;

    if (!pageHeading) {
      return null;
    }

    if (options.flexComponentView === "hidden") {
      return <h2 className="sr-only">{formatText("wizard.a11y.header")}</h2>;
    }

    return (
      <div className="uitk-cell all-t-padding-one all-b-padding-four">
        <UitkHeading level={1} size={headingSize}>
          {pageHeading}
        </UitkHeading>
      </div>
    );
  })
);

export default PageHeadingWizard;
